import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TractorViewModel } from "@app/shared/models/tractors/TractorViewModel.model";

@Component({
  selector: "app-tractor-specs",
  templateUrl: "./tractor-specs.component.html",
  styleUrls: ["./tractor-specs.component.css"],
})
export class TractorSpecsComponent implements OnInit, OnChanges {
  @Input() tractor: TractorViewModel;
  @Input() isEditMode: boolean;

  @Output() hasChanges = new EventEmitter<boolean>();

  private originalTractor: string;
  fuelTypeOptions = [
    { label: "Diesel", value: "DIESEL" },
    { label: "CNG", value: "CNG" }
  ];

  constructor() {}

  ngOnInit() {
    this.originalTractor = JSON.stringify(this.tractor);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["tractor"] && !changes["tractor"].firstChange) {
      this.originalTractor = JSON.stringify(this.tractor);
      this.checkForChanges();
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  private checkForChanges() {
    const currentTractor = JSON.stringify(this.tractor);
    const changed = currentTractor !== this.originalTractor;
    this.hasChanges.emit(changed);
  }
}

